module.exports = __webpack_public_path__ + "static/media/Deerling_gaussian2.8f1eaca9.png";